import { Badge } from 'react-bootstrap';
import { I18n } from '@/i18n/I18n';
import { McpActionStatus } from '@/types/mcpTypes';

const STATUS_VARIANTS: Record<McpActionStatus, { bg: string; text?: 'dark' }> = {
  [McpActionStatus.PENDING]: { bg: 'warning', text: 'dark' },
  [McpActionStatus.EXECUTING]: { bg: 'info', text: 'dark' },
  [McpActionStatus.SUCCEEDED]: { bg: 'success' },
  [McpActionStatus.FAILED]: { bg: 'danger' },
  [McpActionStatus.REJECTED]: { bg: 'secondary' },
  [McpActionStatus.CANCELLED]: { bg: 'secondary' },
  [McpActionStatus.EXPIRED]: { bg: 'secondary' },
};

/** The status of one proposed change, as shown on the approvals page. */
export function McpStatusBadge({ status }: { status: McpActionStatus }) {
  const { bg, text } = STATUS_VARIANTS[status];
  return <Badge bg={bg} text={text}>{I18n.get(`aiStatus_${status}`)}</Badge>;
}
